<template>
  <div class="v-button-wrapper">
    <v-tooltip
      top
      :disabled="!tooltipMessage"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          :id="generateId"
          data-testid="v-btn"
          :type="type"
          :color="color"
          :loading="loading"
          class="mx-1 naj-button"
          :class="{
            light,
            square,
            small: size === 'small',
            'x-small': size === 'x-small',
            'inputs-alignment': inputsAlignment,
            'append-icon': appendIcon
          }"
          v-bind="{ [size]: !!size, text, outlined, disabled: disabled || loading }"
          :to="to"
          :href="href"
          :target="target"
          @click="clickHandler"
          v-on="on"
        >
          <v-icon v-if="icon">
            {{ icon }}
          </v-icon>
          <slot />
        </v-btn>
      </template>
      <span v-html="tooltipMessage" />
    </v-tooltip>
  </div>
</template>

<script>
import { generateHtmlTagId } from '@/helpers/utils';

export default {
  name: 'NajButton',
  props: {
    type: {
      required: false,
      default: 'button',
    },
    color: {
      required: false,
      default: 'primary',
    },
    icon: { required: false },
    loading: {
      required: false,
      default: false,
    },
    light: { type: Boolean },
    square: { type: Boolean },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      required: false,
      default: '',
      validator(value) {
        // the value must be one of this array items
        return !value || ['large', 'small', 'x-small'].indexOf(value) !== -1;
      },
    },
    text: { required: false },
    outlined: { required: false },
    inputsAlignment: {
      type: Boolean,
      required: false,
    },
    appendIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    to: {
      type: [String, Object],
      required: false,
    },
    href: {
      type: String,
      required: false,
    },
    target: {
      type: String,
      required: false,
      default: '_self',
    },
    tooltipMessage: {
      type: String,
      required: false,
    },

  },
  computed: {
    generateId() {
      return generateHtmlTagId(this, 'btn');
    },
  },
  methods: {
    clickHandler(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-button-wrapper {
  display: inline-block;
  &::v-deep {
    .v-btn__content {
      display: flex;
    }
    // to move the icon to left
    .append-icon {
      .v-btn__content {
        flex-direction: row-reverse;
      }
    }
  }

  &::v-deep .naj-button {
    box-shadow: none;
    padding: 7px 14px !important;
    border-radius: 2.4px;
    // min-height: 50px;
    letter-spacing: normal;
    border-width: 1px;

    span {
      font-weight: 400;
      font-size: 16px;
    }

    &.primary {
      // min-width: 160px;

      // Important is wrong here, But i added to only overwrite vutify.
      background-color: #203f39 !important;

      span {
        color: #fff;
      }
    }

    .v-icon {
      width: 14px;
      height: 14px;
      font-size: 14px !important;
      position: relative;
      margin-left: 4px;
    }
    &.append-icon {
      .v-icon {
        margin-right: 4px;
        margin-left: 0;
      }
    }

    .v-btn__content {
      color: #fff !important;
    }

    &.v-btn--outlined.primary--text {
      border-color: rgb(137, 116, 62);
      background-color: rgb(137, 116, 62);

      span {
        color: rgb(137, 116, 62);
      }

      .v-icon {
        width: 20px;
        height: 20px;
        position: relative;
        right: -15px;
      }

      &.small {
        .v-icon {
          width: 18px;
          height: 18px;
          position: relative;
          right: -5px;
          font-size: 18px;
        }
      }

      &.x-small {
        .v-icon {
          display: none;
        }
      }
    }

    // Light case
    &.light {
      // Important is wrong here, But i added to only overwrite vutify.
      background-color: #01ac66 !important;
      box-shadow: 0 0 8px #9adcc1;
      min-width: 219px;

      span {
        font-size: 17px;
      }
    }

    &.square {
      min-width: 104px;
      border-radius: 4px;
    }

    // Size
    &.small {
      min-height: 33px;
      font-weight: 500;
      padding-left: 15px !important;
      padding-right: 15px !important;

      span {
        font-size: 16px;
      }

      .v-icon {
        width: 30px;
        height: 20px;
        position: relative;
        right: -5px;
      }
    }
    &.x-small {
      min-height: 30px;
      font-weight: 500;
      padding-left: 10px !important;
      padding-right: 10px !important;

      span {
        font-size: 14px;
      }
    }
  }
}
.inputs-alignment {
  margin-top: 26px;
}
.theme--light.v-btn.primary.v-btn--disabled:not(.v-btn--flat):not(
    .v-btn--text
  ):not(.v-btn--outlined) {
  background-color: #009587 !important;
}
</style>
